import { ReactElement } from 'react'

const strings = {
  button: {
    accountManager: 'ACCOUNT MANAGER',
    addCard: 'ADD ACCOUNT',
    alerts: 'Alerts',
    alertsTooltip: 'Manage enrollment in Alerts',
    clickHere: 'click here',
    makeAPayment: 'Make a Payment',
    paymentOptions: 'View Payment Options',
    paymentPlan: 'View Payment Plan',
    reload: 'reload',
    signOut: 'Sign Out',
    activity: 'Activity',
    back: 'BACK',
    goBackHome: 'Go Back Home',
    languageText: 'Español',
    close: 'Close',
    agreeAndContinue: 'AGREE & CONTINUE',
    registerAccount: 'REGISTER ACCOUNT',
    viewMyAccount: 'View My Account',
    statements: 'Statements',
    rewards: 'Rewards',
    accountDetails: 'Details',
    viewAllActivity: 'View all activity',
    activateCard: 'Activate Card',
    documentCenter: 'Document Center',
    profileManagement: 'Manage Profile',
    marketingSetting: 'Marketing & Privacy Settings',
    signInSecurity: 'Sign In Security',
    missingSynchronyAccount: 'Missing Synchrony Account?',
    more: 'More',
    accountManagerReturn: 'RETURN TO ACCOUNT MANAGER',
    creditBalanceRefund: 'Manage Your Credit Balance',
    crossBorderOpenTab: 'Open Tab',
    cancel: 'CANCEL',
    creditLimitIncrease: 'Credit limit increase',
    changePaymentDueDate: 'Change payment due date',
    activateACard: 'Activate a card',
    freezeCard: 'Freeze card',
    replaceYourCard: 'Replace your card',
    trackYourCard: 'Track your card',
    reportLostStolenCard: 'Report lost or stolen card',
    createChangePIN: 'Create/change PIN',
    customCardArt: 'Customize your CareCredit card',
    updateIncome: 'Update income',
    addAccount: 'Add Synchrony Account To Manager',
    yourCreditScore: 'Your Credit Score',
    manageCardholders: 'Manage cardholders',
    creditViewDashboard: 'CreditView™ Dashboard',
    exploreOffers: 'Explore Offers',
    makeAPaymentOffline: 'Still looking to make a payment?',
    requestPastStatements: 'Request past statements',
    paymentSecurity: 'Payment Security',
    cardAccess: 'Add card to digital wallet',
    disputeATransaction: 'Dispute a transaction',
    manageYourDisputes: 'Manage your disputes',
    balanceTransferOffers: 'Balance Transfer Offers',
    backTo: 'Back To',
    signInToAccountManager: 'Sign In to account manager'
  },
  labels: {
    accountActions: 'Account Actions',
    accountDetails: 'Account Details',
    accountEndingIn: 'Account ending in',
    accountsServices: 'Account Services',
    cardActions: 'Card Actions',
    activityMenu: 'Activity',
    promotionsMenu: 'Promotions',
    security: 'Security',
    loanEndingIn: 'Loan ending in',
    dueDate: 'Payment Due Date',
    monthlyPaymentAmount: 'Monthly Payment Amount',
    totalMinimumPayment: 'Total Minimum Payment',
    noPaymentDue: 'No Payment Due',
    forHelp: 'for help.',
    creditLimit: 'Credit Limit',
    currentBalance: 'Current Balance',
    totalPaid: 'Total Paid',
    availableToSpend: 'Available to spend',
    accountSnapshot: 'ACCOUNT SNAPSHOT',
    totalRemaining: 'Total Remaining',
    monthlyPayment: 'Monthly Payment',
    currentBalanceTooltip: 'May not reflect recent transactions.',
    unavailable: 'Unavailable',
    recentActivity: 'Recent Activity',
    currentBalanceAlt: 'Current Balance Information',
    loanAmount: 'Loan Amount',
    totalLoanBalance: 'Total Loan Balance',
    nextAmountDue: 'Next Amount Due',
    nextAmountDueTooltip: 'Includes any fees and past due amounts',
    totalLoanBalanceTooltip:
      'The Total Loan Balance may change for various reasons (e.g. payments and returns). If applicable, the Total Loan Balance may increase as items are fulfilled.',
    crossBorderText:
      'The information shared at this link is not part of Synchrony Bank. Please note that because this site you are going to is not controlled by Synchrony Bank, you will be subject to the terms of use and privacy policy of the website you are visiting.',
    yourAccounts: 'Your Accounts',
    addAccount: 'Add Account',
    addAccountContent:
      'To add an existing Synchrony credit card account of which you are the primary owner, enter the information below.',
    accountNumberPlaceholder: 'Credit card number',
    ssnPlaceholder: 'Last 4 of digits of SSN/ITIN',
    dobPlaceholder: 'Date of birth (MM/DD/YYYY)',
    ssnHelpText: 'Social Security Number/Individual Taxpayer ID Number',
    dobHelpText: 'Primary account holder’s date of birth (MM/DD/YYYY)',
    statements: 'Statements'
  },
  autopay: {
    text: 'Autopay',
    on: 'ON',
    off: 'OFF'
  },
  overlayMessages: {
    accountUpgrading: 'Your Account is being Upgraded!',
    attentionRequired: 'Your Attention is Required',
    checkBackForDetails: 'Check back soon to view your account details.',
    careCreditUnavailable: 'CareCredit Rewards are currently unavailable',
    checkBackLater: 'Please check back later',
    contactInfo: 'Please contact customer service at 1-800-542-5593.',
    detailsUnavailable: 'Account Details Unavailable',
    issueWithAccount: 'There is an issue with your account.',
    noInformation:
      'We are having trouble retrieving information for this account.',
    setpayLoanProcessing: 'We’re still processing your SetPay loan details.',
    tryLater: 'Please try again later.',
    activationReady: ({
      displayName
    }: {
      displayName: ReactElement
    }): ReactElement => (
      <>Your new card for {displayName} is ready for activation.</>
    ),
    clickActivateButton: 'Click the button below to get started.'
  },
  errors: {
    littleTrouble:
      "Sorry, we're having a little trouble getting this information.",
    pleaseReload:
      'Please reload the page or try again later. If the problem continues, ',
    pageNotFound:
      'The page you’re looking for either doesn’t exist or can’t be found.',
    sorryPage: "Sorry, we couldn't find that page.",
    weApologize: 'We Apologize',
    technicalDifficulties:
      'We are currently experiencing technical difficulties and are unable to access your account.',
    unableToFindAccount:
      'While your login was successful, we are unable to find the account associated with your credentials.',
    pleaseTryAgain: 'Please try again later.',
    tryAgain: 'Try Again',
    tryAgainLater:
      'Please try again later or contact customer service for assistance.',
    accountClosedOrBlocked: 'This account may have been closed or blocked.',
    contactCustomerService:
      'Please contact customer service at the number on the back of your card.',
    emptyAccountNumber: 'Enter credit card number',
    emptySSN: 'Enter last 4 digits of your SSN/ITIN',
    emptyDOB: 'Enter the primary account holder’s date of birth (MM/DD/YYYY)',
    wrongAccountNumber: 'Check credit card number',
    wrongSSN: 'Last 4 digits of SSN/ITIN required',
    wrongDOB: 'Must follow MM/DD/YYYY format',
    pastDOB: 'Birth year occurs too far in the past',
    futureDOB: 'This date occurs in the future',
    incorrectInfoDescripton:
      'Please check that you are trying to add a Synchrony account and enter your information again.',
    cannotLoadAccounts: 'We can’t load your account at this time.'
  },
  welcomeInterstitial: {
    welcomeTitle: 'Welcome to your account manager',
    manageAccountSubTitle:
      'A simpler, faster and more convenient way to manage your Synchrony accounts.',
    legalStatement: 'communications agreement',
    note: 'Note:',
    welcomeNote:
      'Your agreement does not change your current statement delivery setting. Your statement delivery settings will not change unless we notify you in the future or you make the changes yourself by logging into your account.',
    eConsentStatement: ({
      legalStatementLink
    }: {
      legalStatementLink: ReactElement
    }): ReactElement => (
      <>By using the account manager, you agree to our {legalStatementLink}.</>
    )
  },
  personalGreeting: {
    morning: 'Good Morning',
    afternoon: 'Good Afternoon',
    evening: 'Good Evening'
  },
  footer: {
    body: 'Your credit accounts are issued by Synchrony Bank.  The Synchrony Bank Privacy Policy governs the use of your credit accounts.  The use of this site is governed by the use of the Synchrony Bank Online Privacy Policy. The content and documents displayed may not all be provided in Spanish.',
    privacyPolicy: 'Online Privacy Policy',
    privacyPolicyLink: 'privacy-policy.html',
    usageAgreement: 'Online Usage Agreement',
    usageAgreementLink: 'terms-of-use.html ',
    fraudProtection: 'Fraud Protection',
    fraudProtectionlink: 'fraud-protection.html',
    accessibility: 'Accessibility',
    accessibilityLink: 'web-accessibility-statement',
    caDoNotSellShare: 'CA Residents - Do Not Sell/Share',
    caDoNotSellShareLink: 'legal/privacy-policy#ccpa-do-not-share-sell',
    cookieSettings: 'Cookie Settings'
  },
  inactivityModal: {
    modalTitle: 'Session Timeout',
    promptTitle: 'Are you still there?',
    countdownWarning: 'Your online session will expire in',
    continueButton: "I'm still here",
    logOffButton: 'Log Off',
    seconds: 'seconds.'
  },
  logout: {
    pageTitle: 'Signed Out',
    cardTitle: 'Thank you for managing your Synchrony accounts.',
    cardDescription: "You've securely signed out.",
    button: 'Sign back in'
  },
  addAccountModal: {
    maxAttemptsTitle: 'Max attempts reached',
    maxAttemptsDescription:
      'Please make sure this is a Synchrony credit card account and try again later or call the customer service number on your card or statement.',
    successTitle: 'Success',
    successDescription: "We've added your account!",
    alreadyAddedTitle: 'This account already added',
    alreadyAddedDescription:
      'You can view this account on your account manager.',
    unableToAddTitle: 'Account unable to be added at this time',
    unableToAddMessage:
      'If this is a new account, please allow 72 hours for your account to be added to your dashboard.',
    syfIDErrorTitle: 'Something went wrong while adding this account',
    callCustomerService:
      'Please call the customer service number on the back of your card or on your statement for more information.',
    generalErrorTitle: 'We are having trouble finding that account',
    somethingWrongTitle: 'We are currently experiencing technical difficulties',
    notSupportedTitle: 'This account is not supported on this platform',
    notSupportedDescription:
      'We’re sorry, but this account is not serviceable on this website. Please utilize your existing sign in channel to access this account.'
  },
  marketPlace: {
    title: 'Shop brands you love',
    description:
      'Find savings on your next purchase through Synchrony Marketplace.'
  },
  notificationCenter: {
    headerTitle: 'Notifications',
    annualNetIncomeTitle: 'Your annual net income requires attention',
    annualNetIncomeDescription:
      'We need you to update your annual net income on the following account(s):',
    updateIncomeLinkTitle: 'Update your income',
    postOfficeReturnTitle: 'Your mailing address requires attention',
    postOfficeReturnDescription:
      'We need you to update your mailing address on the following account(s):',
    updateMailAddressLinkTitle: 'Update mailing address',
    updateEmailTitle: 'Your email address requires attention',
    updateEmailDescription:
      'We need you to update your email address on the following account(s):',
    updateEmailLinkTitle: 'Update email address'
  },
  creditView: {
    creditViewHeader: 'Track your credit health!',
    creditViewSubtitle:
      'Unlock free access to your CreditView™ Dashboard where you can view your credit score, monitor your financial health, and more!',
    scoreOverview: 'Credit score overview',
    scoreTrending: 'Credit score trending',
    creditSimulator: 'Credit simulator',
    managementTips: 'Tips on debt and money management',
    nationalScore: 'National score comparison',
    launchCreditView: 'LAUNCH CREDITVIEW DASHBOARD',
    disclaimer:
      'At this time, the CreditView™ Dashboard is not offered in Spanish.',
    footerDisclaimer:
      'Clicking “CreditView™ Dashboard” will direct you to the TransUnion CreditView™ Dashboard site, which is not owned or operated by Synchrony. Access to the site is available to you as the primary cardholder of a myWalgreens Credit Card account issued by Synchrony Bank. Walgreens/Synchrony have no responsibility for the content provided on the CreditView™ Dashboard site. Please review the CreditView™ Dashboard Privacy Policy to understand how TransUnion will treat the information you provide while using the site. The free VantageScore® credit score is for educational purposes only and is not used by Synchrony to make credit decisions. There are various types of credit scores and lenders who use different types of scores to make lending decisions. The credit score you receive is based on the VantageScore 3.0 model and may not be the credit score model used by your lender.',
    errorTitle: 'We’re having technical trouble',
    errorMessage:
      'We are currently experiencing technical difficulties and are unable to access CreditView™.',
    accountManager: 'ACCOUNT MANAGER'
  },
  modal: {
    changeDueDateTitle: 'Change Due Date',
    creditLimitIncreaseTitle: 'Credit Limit Increase',
    manageCardholdersTitle: 'Manage Cardholders',
    makeAPaymentModalTitle: 'Make a Payment',
    cardStatusTrackerTitle: 'Track Your Card'
  },
  collectionsModal: {
    modalTitle: 'Payment Options'
  },
  search: {
    placeholder: 'Search',
    ariaLabel: 'Search site features',
    clear: 'Clear search',
    noResults: 'No matching features found',
    selectAccount: 'Select an account',
    featureUnavailable: 'This feature is not available for your accounts',
    categoryAccountActions: 'Account Actions',
    categoryCardActions: 'Card Actions',
    categorySecurity: 'Security',
    categoryPages: 'Pages'
  },
  searchTags: {
    'account-details':
      'apr, available, balance, info, limit, number, summary, terms',
    'account-services':
      'account, configure, features, manage, options, preferences, services, settings, tools',
    'activate-card':
      'activate, begin, card, enable, mail, new, received, register, setup, start',
    activity:
      'bought, charges, history, payments, pending, purchases, recent, spending, spent, transactions, where',
    'add-account':
      'account, add, another, card, connect, credit, existing, link, missing, new, register, synchrony, verify',
    alerts:
      'alerts, email, notifications, notify, push, reminders, settings, sms, subscribe, text, warning',
    'balance-transfer':
      'balance, combine, consolidate, debt, interest, move, offer, payoff, rate, switch, transfer',
    'card-status-tracker':
      'arrive, coming, delivery, eta, mail, order, shipped, shipping, status, track, where',
    'change-payment-due-date':
      'billing, cycle, date, deadline, due, monthly, move, schedule, shift, when',
    'create-change-pin':
      'advance, atm, cash, change, code, forgot, number, pin, reset, security, set',
    'credit-balance-refund':
      'back, balance, credit, money, negative, overpaid, refund, reimburse, return',
    'credit-limit-increase':
      'available, credit, higher, increase, limit, line, max, more, power, raise, spending, upgrade',
    'credit-score':
      'bureau, check, credit, equifax, fico, monitoring, rating, report, score, transunion, vantage',
    'credit-view':
      'analysis, factors, health, insights, monitor, overview, trends',
    'digital-collections':
      'arrangement, assistance, behind, collections, delinquent, hardship, late, missed, options, overdue, past, payment, plan, settlement',
    'dispute-a-transaction':
      'charge, chargeback, claim, dispute, duplicate, error, fraud, incorrect, mistake, refund, return, transaction, unauthorized, unrecognized, wrong',
    'disputes-center':
      'claims, disputes, manage, open, pending, resolution, status, track',
    'document-center':
      'agreements, correspondence, disclosures, documents, forms, letters, mail, notices, paperless, tax, terms',
    'freeze-card':
      'block, card, deactivate, disable, freeze, hold, lock, pause, stop, suspend, temporary',
    'make-a-payment':
      'amount, autopay, balance, bill, due, method, minimum, money, monthly, owe, pay, recurring, scheduled, send',
    'manage-cardholders':
      'add, additional, authorized, cardholder, family, joint, remove, secondary, share, spouse, user',
    'marketing-privacy':
      'advertising, consent, cookies, data, marketing, optout, preferences, privacy, sharing, targeted, unsubscribe',
    'payment-security':
      'coverage, disability, hardship, insurance, job, loss, plan, protection, sick, unemployment',
    profile:
      'address, contact, details, edit, email, income, info, mailing, mobile, name, personal, phone, salary, update',
    promotions: 'financing, interest, offer, plan, promo, special',
    'replace-your-card':
      'broken, chip, cracked, damaged, defective, expired, new, order, plastic, reissue, replacement, worn',
    'report-lost-stolen':
      'compromised, disappeared, emergency, fraud, gone, lost, missing, robbed, steal, stolen, taken, theft',
    'request-past-statements':
      'archive, copy, history, mail, older, past, previous, request, statement',
    rewards:
      'bonus, cashback, certificate, earnings, exchange, gift, loyalty, miles, offers, perks, points, redeem',
    statements:
      'billing, download, history, monthly, paperless, past, pdf, print, receipt, statement, view',
    'update-income':
      'annual, earnings, employment, income, job, salary, update, wages'
  }
}

export default strings
